import React from 'react';
import { Helmet } from 'react-helmet';

const GTM = () => {
  return (
    <div>
      <Helmet>
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-W7JJ54X');
          `}
        </script>
      </Helmet>
      <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W7JJ54X"
        height="0" width="0" style={{ display: 'none', visibility: 'hidden' }}></iframe>
      </noscript>
    </div>
  );
};

export default GTM;
